import React, { useState } from "react";
import { useForm } from "@mantine/form";
import { NumberInput, TextInput, Textarea } from "@mantine/core";

import * as slideUpFormStyles from "./slideUpForm.module.scss";
import ButtonComponent from "../Home/ButtonComponent/ButtonComponent";
import { ndeFormInstance } from "../../lib/axios-client";
import { toast } from "react-toastify";
import { navigate } from "gatsby";

export default function SlideUpForm() {
  const [apiLoading, setApiLoading] = useState(false);
  const form = useForm({
    mode: "uncontrolled",
    initialValues: {
      name: undefined,
      phoneNumber: undefined,
      email: "",
      items: [
        {
          id: 1,
          label: "Website Design",
          text: "Website Design",
          checked: false,
        },
        { id: 2, label: "Web App", text: "Web App", checked: false },
        { id: 3, label: "Mobile App", text: "Mobile App", checked: false },
        { id: 4, label: "Branding", text: "Branding", checked: false },
      ],
      comment: "",
    },

    validate: {
      name: (value) => {
        const trimmed = value?.trim();
        if (!trimmed) return "Name is required!";
        return trimmed.length < 3 ? "Name must contain at least 3 letters!" : null;
      },
      email: (value) => {
        const trimmed = value?.trim();
        if (!trimmed) return "Email is required!";
        return /^\S+@\S+$/.test(trimmed) ? null : "Please enter a valid email!";
      },
      items: (items) => items?.some(item => item.checked) ? null : "Please select at least one checkbox!",
      comment: (value) => {
        const trimmed = value?.trim();
        if (!trimmed) return "Comment is required!";
        return trimmed.length > 250 ? "Comment must be 250 characters or less" : null;
      }
    }
  });
  const handleCheckboxChange = (index, checked) => {
    const updatedItems = [...form.values.items];
    updatedItems[index].checked = checked;
    form.setFieldValue("items", updatedItems);
  };
  const handleCheckBoxOuterCardClick = (index) => {
    const updatedItems = [...form.values.items];
    updatedItems[index].checked = !updatedItems[index].checked;
    form.setFieldValue("items", updatedItems);
  };

  async function handleSubmit(data) {
    const trimmedData = {
      ...data,
      name: data?.name?.trim(),
      email: data?.email?.trim(),
      comment: data?.comment?.trim()
    };

    setApiLoading(true);
    
    try {
      const landing_page = sessionStorage.getItem('landing_page');
      await ndeFormInstance.post('/quote', { ...trimmedData, landing_page });
      if (window.dataLayer) {
        window.dataLayer.push({
          event: "quote-form-submitted",
          ...trimmedData,
        });
      }
      navigate("/thank-you");
    } catch (error) {
      toast.error(error.message);
      console.error(error);
    } finally {
      setApiLoading(false);
    }
  }

  return (
    <div className={slideUpFormStyles.slideUpForm}>
      <div className={slideUpFormStyles.slideUpForm__container}>
        <div className={slideUpFormStyles.slideUpForm__formCard}>
          <p className={slideUpFormStyles.slideUpForm__formSubtitle}>
            ASK FOR A QUOTE
          </p>
          <h3 className={slideUpFormStyles.slideUpForm__formTitle}>
            What do you need?
          </h3>
          <form onSubmit={form.onSubmit(handleSubmit)}>
            <h4 className={slideUpFormStyles.slideUpForm__formLabel}>Services*</h4>
            <div className={slideUpFormStyles.slideUpForm__formCategory}>
              {form.values.items.map((item, index) => (
                <div
                  className={slideUpFormStyles.slideUpForm__categoryCard}
                  key={item.id}
                  onClick={() => handleCheckBoxOuterCardClick(index)}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter') {
                      handleCheckBoxOuterCardClick(index);
                    }
                  }}
                  role="button"
                  tabIndex="0"
                >
                  <input
                    checked={item.checked}
                    onChange={(event) =>
                      handleCheckboxChange(index, event.currentTarget.checked)
                    }
                    type="checkbox"
                    id={item.id}
                    className={slideUpFormStyles.slideUpForm__checkBox}
                  />
                  <span className={slideUpFormStyles.slideUpForm__content}>
                    {item.text}
                  </span>
                </div>
              ))}
            </div>
            {form.errors.items && (
              <p className={slideUpFormStyles.slideUpForm__formCategoryError}>
                {form.errors.items}
              </p>
            )}
            <div className={slideUpFormStyles.slideUpForm__formContainer}>
              <h4 className={slideUpFormStyles.slideUpForm__title}>
                More about you
              </h4>
              <div className={slideUpFormStyles.slideUpForm__nameEmail}>
                <TextInput
                  placeholder="What is your name?*"
                  key={form.key("name")}
                  {...form.getInputProps("name")}
                  className={slideUpFormStyles.slideUpForm__name}
                  size="lg"
                />

                <TextInput
                  placeholder="Your email for contact*"
                  key={form.key("email")}
                  {...form.getInputProps("email")}
                  className={slideUpFormStyles.slideUpForm__email}
                  size="lg"
                />
                <NumberInput
                  rightSection={""}
                  placeholder="Phone Number"
                  key={form.key("phoneNumber")}
                  {...form.getInputProps("phoneNumber")}
                  className={slideUpFormStyles.slideUpForm__phoneNumber}
                  size="lg"
                />
              </div>

              <Textarea
                placeholder="Comment*"
                key={form.key("comment")}
                {...form.getInputProps("comment")}
                className={slideUpFormStyles.slideUpForm__comment}
                size="lg"
              />
              <div className={slideUpFormStyles.slideUpForm__submitButton}>
                <ButtonComponent
                  buttonText={"Send Email"}
                  buttonStyle={"solidBg"}
                  type={"submit"}
                  className={slideUpFormStyles.slideUpForm__Button}
                  disabled={apiLoading}
                  loading={apiLoading}
                />
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}
